import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

export function ScrollableContentContainer({
  height,
  children,
  ...props
}: PropsWithChildren<
  { height: string } & DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
>) {
  return (
    <div
      {...props}
      className={`ui segment ${props.className}`}
      style={{ maxHeight: `${height}`, overflow: 'auto', ...props.style }}>
      {children}
    </div>
  );
}
